// removed by extract-text-webpack-plugin
module.exports = {"link":"arrow-link__link___2QYIO","icon":"arrow-link__icon___3cYLA","icon-next":"arrow-link__icon-next___15W3f","inner":"arrow-link__inner___1k_QB","text":"arrow-link__text___3jqg_"};


//////////////////
// WEBPACK FOOTER
// ./app/components/shared/ArrowLink/arrow-link.scss
// module id = 936
// module chunks = 0